




















































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import config from '@/config/index';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/Clientes/FiltrosBusqueda.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { postReporteTime } from '@/pantallas/Informes/partes/postReporteTime';
import MensajeValidacionHRef from '@/pantallas/Informes/partes/MensajeValidacionHRef.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MensajeValidacion from '../../../reusable/Mantenedor/MensajeValidacion.vue';
import { fetchTelemetria } from '@/pantallas/Telemetria/fetchTelemetria';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef_DEPRECATED,
  creadoPorColumnDefs,
  modificadoPorColumnDefs,
  fechaCreacionColumnDefs,
  fechaModificacionColumnDefs,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { LoadingService } from '@/services/loadingService';
import HandleErrors from '@/config/handleErrors'; //
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import VerDetalleModal from '@/pantallas/Peajes/Tarifas/VerDetalleModal.vue';
import moment from 'moment';
import { Bar, Line, Doughnut, Radar } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { type } from 'os';
@Component({
  components: {
    MantenedorGridSinCodigo,
    FiltrosBusqueda,
    VerDetalleModal,
    DatePicker,
    TimePicker,
    MensajeValidacion: MensajeValidacionHRef,
    FormFieldsContainer,
    doughnutComp: Doughnut,
    barComp: Bar,
    lineComp: Line,
    AgGridVue,
  },
})
export default class Telemetria extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.TarifasPeajes;
  accionesTotales: PermisoAccion[] = [];

  requestsStart: number = 0;
  fechaDesde: any = moment(new Date()).add(-1, 'weeks');
  fechaHasta: any = moment();
  horaDesde: any = moment('00:00', 'HHmm');
  horaHasta: any = moment('23:59', 'HHmm');

  vehiculos: any = [];
  vehiculosSeleccionados: any = [];
  busqueda: boolean = false;
  isFormValid: boolean = false;

  data: any = {};

  gridOptionBar: GridOptions;
  gridApiBar: GridApi;
  barDetailList: any[];

  gridOptionLine: GridOptions;
  gridApiLine: GridApi;
  lineDetailList: any[];


  // submitForm(){
  //   console.log(this.vehiculosSeleccionados)
  //   if(this.vehiculosSeleccionados.length == 0){
  //     this.$snotify.error('Por Favor Seleccione una Patente')
  //     return
  //   }
  // }

  async buscaDashboard() {
    console.log(this.vehiculosSeleccionados);
    var valid = await this.$validator.validateAll();
    if (!valid) {
      return;
    }

    const body: {} = {
      fini:
        this.fechaDesde.format('YYYY-MM-DD').toString() +
        ' ' +
        this.horaDesde.format('HH:mm:ss').toString(),
      ffin:
        this.fechaHasta.format('YYYY-MM-DD').toString() +
        ' ' +
        this.horaHasta.format('HH:mm:ss').toString(),
      vehiculos: [this.vehiculosSeleccionados.toString()],
    };
    this.loadingService.showLoading();
    fetchTelemetria(body, 'getEventosTelemetria')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.data.length === 0) {
            // self.gridApi.setRowData([{}]);
            this.$snotify.success('Sin Datos');
            this.busqueda = false;
            // params.successCallback([{}], 0);
            // self.gridApi.showNoRowsOverlay();
          } else {
            this.data = response.data.data;
            this.busqueda = true;
            // this.vehiculos = response.data.data
            // params.successCallback(
            //   response.data.data,
            //   response.data.data.length
            // );
            // self.gridApi.hideOverlay();
          }
        } else {
          this.$snotify.error('Sin Registros');
          this.busqueda = false;
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading();
        // this.mountGraphicRecorrido()
      });
  }

  mounted() {
    this.getVehiculos();
    // (this.$refs.doughnutCompRef as Doughnut).addPlugin(ChartDataLabels);
    // this.mountGraphicRecorrido();

    this.gridOptionBar = {
      rowSelection: 'multiple',
      columnDefs: [{
        headerName: 'Patente',
        field: 'rego',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },{
        headerName: 'Código vehículo',
        field: 'cod_vehiculo',
        hide: true,
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },{
        headerName: 'Fecha',
        field: 'fecha_dia',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },{
        headerName: 'Litros combustible',
        field: 'consume_acum_final_trayecto',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      }],
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      onGridReady: this.onGridReadyBar,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: config.agGridDefaultConfig,
      blockLoadDebounceMillis: 350,
      columnTypes: {
      },
    }

    this.gridOptionLine = {
      rowSelection: 'multiple',
      columnDefs: [{
        headerName: 'Patente',
        field: 'rego',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },{
        headerName: 'Código vehículo',
        field: 'cod_vehiculo',
        hide: true,
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },{
        headerName: 'Fecha',
        field: 'fecha_dia',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },{
        headerName: 'Rendimiento',
        field: 'ratio',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      }],
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      onGridReady: this.onGridReadyLine,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: config.agGridDefaultConfig,
      blockLoadDebounceMillis: 350,
      columnTypes: {
      },
    }
  }


  async onGridReadyBar(params: GridReadyEvent) {
    this.gridApiBar = params.api;
    this.gridApiBar.setRowData([]);
    this.gridApiBar.setDomLayout('autoHeight');
  }

  async onGridReadyLine(params: GridReadyEvent) {
    this.gridApiLine = params.api;
    this.gridApiLine.setRowData([]);
    this.gridApiLine.setDomLayout('autoHeight');
  }
  

  @Watch('data')
  ondataChanged(value: string, oldValue: string) {
    setTimeout(this.cargarGrafico, 500);
  }

  cargarGrafico() {
    (this.$refs.doughnutCompRefRecorrido as Doughnut).addPlugin(
      ChartDataLabels
    );
    (this.$refs.doughnutCompRefConsumo as Doughnut).addPlugin(ChartDataLabels);
    (this.$refs.doughnutCompRefTiempo as Doughnut).addPlugin(ChartDataLabels);
    this.mountGraphicRecorrido();
    this.mountGraphicConsumo();
    this.mountGraphicTiempo();
    this.mountGraphicBar();
    this.mountGraphicLine();
  }

  mountGraphicBar(){
    let data:any = {};
    try {
      data = this.data.graficos[0].barras;
      this.gridApiBar.setRowData(this.data.graficos[0].detalle_barras);
    } catch (e) {
      console.log(e)
      this.$snotify.error('Error al procesar los gráficos de consumo de combustible');
      return;
    }

    (this.$refs.barFuelComp as Bar).renderChart(
      {
        labels: data.labels,
        datasets: [
          {
            label: 'Litros combustible',
            data: data.values,
            backgroundColor: (data.hasOwnProperty('color') ?  data.color : '#2a84de'),
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          },
        },
      }
    );
  }

  mountGraphicLine(){
    let data:any = {};
    try {
      data = this.data.graficos[0].lineas;
      this.gridApiLine.setRowData(this.data.graficos[0].detalle_lineas);
    } catch (e) {
      console.log(e)
      this.$snotify.error('Error al procesar los gráficos de consumo de combustible');
      return;
    }

    (this.$refs.lineFuelComp as Line).renderChart(
      {
        labels: data.labels,
        datasets: [
          {
            label: 'Rendimiento Promedio',
            data: data.list1,
            backgroundColor: (data.hasOwnProperty('color') ?  data.color : '#2a84de'),
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          },
        },
      }
    );
  }

  mountGraphicRecorrido() {
    // console.log(this.data.reporte_conduccion[0].recorrido)
    var data = this.formatRecorrido(this.data.reporte_conduccion[0].recorrido);
    (this.$refs.doughnutCompRefRecorrido as Doughnut).renderChart(
      {
        labels: data.labels,
        datasets: [
          {
            label: '',
            data: data.values,
            backgroundColor: data.color,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          },
        },
      }
    );
  }

  formatRecorrido(data: any) {
    var labels: any = ['Con Crucero', 'Sin Crucero'];
    var values: any = [data.distancia_en_crucero, data.distancia_sin_crucero];
    // var values: any = [10,12];
    var color: any = [this.dynamicColors(), this.dynamicColors()];
    return { labels: labels, values: values, color: color };
  }

  mountGraphicConsumo() {
    // console.log(this.data.reporte_conduccion[0].recorrido)
    var data = this.formatConsumo(this.data.reporte_conduccion[0].consumo);
    (this.$refs.doughnutCompRefConsumo as Doughnut).renderChart(
      {
        labels: data.labels,
        datasets: [
          {
            label: '',
            data: data.values,
            backgroundColor: data.color,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          },
        },
      }
    );
  }

  formatConsumo(data: any) {
    var labels: any = ['Detenido no Ralentí', 'Marcha', 'Ralentí'];
    var values: any = [
      data.consumo_detenido_no_ralenti,
      data.consumo_marcha,
      data.consumo_ralenti,
    ];
    // var values: any = [10,12];
    var color: any = [
      this.dynamicColors(),
      this.dynamicColors(),
      this.dynamicColors(),
    ];
    return { labels: labels, values: values, color: color };
  }

  mountGraphicTiempo() {
    // console.log(this.data.reporte_conduccion[0].recorrido)
    var data = this.formatTiempo(this.data.reporte_conduccion[0].tiempo);
    (this.$refs.doughnutCompRefTiempo as Doughnut).renderChart(
      {
        labels: data.labels,
        datasets: [
          {
            label: '',
            data: data.values,
            backgroundColor: data.color,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          },
        },
      }
    );
  }

  formatFloat(data: any) {
    try {
      var fixed = '';
      if (typeof data === 'number') {
        fixed = data.toFixed(2).toString();
      } else {
        fixed = parseFloat(data)
          .toFixed(2)
          .toString();
      }
      return fixed.replace(/\.00$/, '');
    } catch (e) {
      console.log('Error');
    }
  }

  formatTiempo(data: any) {
    var labels: any = ['Detenido no Ralentí', 'Marcha', 'Ralentí'];
    var values: any = [
      data.horometro_detenido_no_ralenti,
      data.horometro_marcha,
      data.horometro_ralenti,
    ];
    // var values: any = [10,12];
    var color: any = [
      this.dynamicColors(),
      this.dynamicColors(),
      this.dynamicColors(),
    ];
    return { labels: labels, values: values, color: color };
  }

  dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  getRut(): any {
    let rut = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user').replace(/'/g, '"'))
          .rutClienteDefecto
      : '';
    return rut;
  }

  async getVehiculos() {
    const body: {} = {
      id_cliente: this.getClientID(),
      id_usuario: this.getUserID().toString(),
      clienteDefecto: this.getClientID(),
      rut: this.getRut(),
    };
    this.loadingService.showLoading;
    fetchTelemetria(body, 'getVehiculos')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          if (response.data.data.length === 0) {
            // self.gridApi.setRowData([{}]);
            this.$snotify.success('Sin Datos');
            this.busqueda = false;
            // params.successCallback([{}], 0);
            // self.gridApi.showNoRowsOverlay();
          } else {
            this.vehiculos = response.data.data;
            // params.successCallback(
            //   response.data.data,
            //   response.data.data.length
            // );
            // self.gridApi.hideOverlay();
          }
        } else {
          this.$snotify.error('Error al traer los registros');
          this.busqueda = false;
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  get fechaMaxima() {
    const fechaMax = moment().format('YYYY-MM-DD h:mm:ss a');
    return fechaMax;
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }
}
